/**
 * SplitText reveal cho mọi phần tử `.split-text` — áp dụng toàn site
 * (tiêu đề, eyebrow, subtitle… bất kỳ đâu gắn class này, xem application/view/template/common/home.twig).
 *
 * Các phần tử `.split-text` cùng chung 1 parent (VD eyebrow + h2 + p trong .timeline-heading)
 * được gom thành 1 "group" và reveal theo đúng thứ tự xuất hiện trong DOM (cascade),
 * cùng chờ 1 điểm cuộn tới (trigger = phần tử đầu group) thay vì chạy đồng thời rời rạc.
 *
 * Chạy sau `qh:page-reveal` (xem main.js) thay vì DOMContentLoaded trực tiếp — nếu chạy ngay lúc
 * DOM parse xong, phần tử `.split-text` above-the-fold sẽ animate xong trong lúc còn bị overlay
 * #page-loader che, user không kịp thấy hiệu ứng.
 */
window.qhOnPageReveal(function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
        return;
    }

    var elements = Array.prototype.filter.call(document.querySelectorAll('.split-text'), function (el) {
        return el.textContent.trim();
    });

    if (!elements.length) {
        return;
    }

    // Gom theo parent chung để biết phần tử nào thuộc cùng 1 khối tiêu đề (thứ tự = thứ tự DOM)
    var groups = [];
    elements.forEach(function (el) {
        var group = groups[groups.length - 1];
        if (!group || group[0].parentElement !== el.parentElement) {
            group = [];
            groups.push(group);
        }
        group.push(el);
    });

    var run = function () {
        if (typeof gsap === 'undefined' || typeof SplitText === 'undefined') {
            return;
        }

        var hasScrollTrigger = typeof ScrollTrigger !== 'undefined';
        gsap.registerPlugin(SplitText, hasScrollTrigger ? ScrollTrigger : null);

        groups.forEach(function (group) {
            var trigger = group[0];

            group.forEach(function (el, index) {
                SplitText.create(el, {
                    type: 'words,chars',
                    autoSplit: true,
                    onSplit: function (self) {
                        return gsap.from(self.chars, {
                            opacity: 0,
                            y: 40,
                            duration: .6,
                            ease: 'power3.out',
                            stagger: .05,
                            delay: index * .15,
                            scrollTrigger: hasScrollTrigger ? {
                                trigger: trigger,
                                start: 'top 85%',
                                once: true
                            } : undefined
                        });
                    }
                });
            });
        });

        // Bọc mỗi chữ/ký tự trong span làm thay đổi chiều cao dòng (line-wrap) của tiêu đề, có thể
        // đẩy lệch vị trí các phần tử nằm bên dưới (VD .module-html__content[data-reveal] trong
        // extension/opencart/catalog/view/template/module/html.twig). scroll-reveal.js chạy cùng lúc
        // DOMContentLoaded nhưng đo vị trí NGAY LẬP TỨC — trước khi SplitText tách chữ xong ở đây (vì
        // run() còn phải chờ document.fonts.ready). Refresh lại toàn bộ ScrollTrigger sau khi split
        // xong để các trigger khác trên trang (kể cả của scroll-reveal.js) tính đúng lại vị trí.
        if (hasScrollTrigger) {
            ScrollTrigger.refresh();
        }
    };

    // Chờ font tải xong trước khi split — tránh đo sai vị trí ký tự khi font swap sau đó
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(run);
    } else {
        run();
    }
});
